import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
/* Components */
import IconButton from '../../common/icon-button/icon-button';
/* Actions */
import {changeDashboardLibraryLayout} from '../../../store/user/user-actions';
/* Styles */
import './dashboard-layout-switch.scss';

class DashboardLayoutSwitch extends Component {
  render() {
    return (
      <div className="glu-flex glu-flex-row glu-flex-justify-end dashboard-layout-switch">
        <IconButton
          icon="grid"
          onClick={this.props.changeDashboardLibraryLayout('grid')}
          className={`${this.props.dashboardLayout === 'grid' ? 'active' : ''}`}
        />
        <IconButton
          icon="list"
          onClick={this.props.changeDashboardLibraryLayout('list')}
          className={`${this.props.dashboardLayout === 'list' ? 'active' : ''}`}
        />
      </div>
    );
  }
}

DashboardLayoutSwitch.propTypes = {
  changeDashboardLibraryLayout: PropTypes.func.isRequired,
  dashboardLayout: PropTypes.string.isRequired,
};

const mapStateToProps = ({userReducer: {dashboardLayout}}) => {
  return {
    dashboardLayout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDashboardLibraryLayout: (layout) => () => changeDashboardLibraryLayout(dispatch, layout),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayoutSwitch);
